/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Expirationdate2Inputs */

const id_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Kedaluwarsa`)
};

const ms_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Tamat Tempoh`)
};

const da_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udløbsdato`)
};

const de_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablaufdatum`)
};

const en_us2_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expiration Date`)
};

const es_es2_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de vencimiento`)
};

const es_mx2_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de vencimiento`)
};

const fil_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Pag-expire`)
};

const fr_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d’expiration`)
};

const it_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di scadenza`)
};

const hu_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lejárati dátum`)
};

const nl_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervaldatum`)
};

const no_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utløpsdato`)
};

const pl_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data wygaśnięcia`)
};

const pt_br2_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de expiração`)
};

const pt_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de expiração`)
};

const ro_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data expirării`)
};

const fi_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanhenemispäivä`)
};

const sv_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgångsdatum`)
};

const vi_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hết hạn`)
};

const tr_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Kullanma Tarihi`)
};

const cs_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vypršení platnosti`)
};

const bg_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на изтичане`)
};

const ru_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата окончания срока`)
};

const uk_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата закінчення терміну дії`)
};

const ar_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ انتهاء الصلاحية`)
};

const hi_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति तिथि`)
};

const th_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่หมดอายุ`)
};

const ja_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効期限`)
};

const zh_cn2_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到期日期`)
};

const zh_hant1_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到期日`)
};

const ko_offerdetail_table_expirationdate2 = /** @type {(inputs: Offerdetail_Table_Expirationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`만료일`)
};

/**
* | output |
* | --- |
* | "Expiration Date" |
*
* @param {Offerdetail_Table_Expirationdate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_expirationdate2 = /** @type {((inputs?: Offerdetail_Table_Expirationdate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Expirationdate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_expirationdate2(inputs)
	if (locale === "ms") return ms_offerdetail_table_expirationdate2(inputs)
	if (locale === "da") return da_offerdetail_table_expirationdate2(inputs)
	if (locale === "de") return de_offerdetail_table_expirationdate2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_expirationdate2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_expirationdate2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_expirationdate2(inputs)
	if (locale === "fil") return fil_offerdetail_table_expirationdate2(inputs)
	if (locale === "fr") return fr_offerdetail_table_expirationdate2(inputs)
	if (locale === "it") return it_offerdetail_table_expirationdate2(inputs)
	if (locale === "hu") return hu_offerdetail_table_expirationdate2(inputs)
	if (locale === "nl") return nl_offerdetail_table_expirationdate2(inputs)
	if (locale === "no") return no_offerdetail_table_expirationdate2(inputs)
	if (locale === "pl") return pl_offerdetail_table_expirationdate2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_expirationdate2(inputs)
	if (locale === "pt") return pt_offerdetail_table_expirationdate2(inputs)
	if (locale === "ro") return ro_offerdetail_table_expirationdate2(inputs)
	if (locale === "fi") return fi_offerdetail_table_expirationdate2(inputs)
	if (locale === "sv") return sv_offerdetail_table_expirationdate2(inputs)
	if (locale === "vi") return vi_offerdetail_table_expirationdate2(inputs)
	if (locale === "tr") return tr_offerdetail_table_expirationdate2(inputs)
	if (locale === "cs") return cs_offerdetail_table_expirationdate2(inputs)
	if (locale === "bg") return bg_offerdetail_table_expirationdate2(inputs)
	if (locale === "ru") return ru_offerdetail_table_expirationdate2(inputs)
	if (locale === "uk") return uk_offerdetail_table_expirationdate2(inputs)
	if (locale === "ar") return ar_offerdetail_table_expirationdate2(inputs)
	if (locale === "hi") return hi_offerdetail_table_expirationdate2(inputs)
	if (locale === "th") return th_offerdetail_table_expirationdate2(inputs)
	if (locale === "ja") return ja_offerdetail_table_expirationdate2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_expirationdate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_expirationdate2(inputs)
	return ko_offerdetail_table_expirationdate2(inputs)
});
export { offerdetail_table_expirationdate2 as "offerDetail.table.expirationDate" }